export default __webpack_public_path__ + "static/media/InsideStomach_12.9ac36132.png";